import React, {useEffect, useState} from 'react';
import FuseAnimate from '@fuse/core/FuseAnimate';
//import { useForm } from '@fuse/hooks';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {submitLogin} from 'app/auth/store/actions';
import HeaderAuth from 'app/main/pages/auth/headerAuth/HeaderAuth'; 
import {useTranslation} from 'react-i18next';
import toast, { Toaster } from 'react-hot-toast';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';
import axios from 'axios';
import {Plane} from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import * as Actions from 'app/store/actions';

const useStyles = makeStyles(theme => ({
	root: {
		background: `radial-gradient(${theme.palette.background.paper} 100%, ${theme.palette.background.paper} 100%)`,
		color: theme.palette.primary.contrastText
	},
	containerLogin: {
		boxShadow: 'none',
		maxWidth: '600px',
		margin: 'auto',
		fontSize: '14px'
	},
	logo: {
		width: '100%',
		marginBottom: '12px'
	},
	forgotPassword: {
		color:`${theme.palette.scaiPro.primary}!important`,
		textAlign: 'center',
		margin: 'auto'
	},
	welcome:{
		fontSize:'3.5rem',
		fontWeight:'bold',
		color: theme.palette.scaiPro.primary,
	},
	txtLogin:{
		fontSize:'2rem',
		color: theme.palette.scaiPro.secondary,
	},
	signUp:{
		color:`${theme.palette.scaiPro.secondary}!important`,
	},
	greyBox: {
		padding: '20px 20px',
		background: '#f9f9f9',
		border: 'solid thin #ccc',
		marginBottom: '35px',
		width: '100%',
		textAlign: 'center',
	},
	notif: {
		marginBottom: '10px',
		fontWeight: 'bold',
		fontSize: '14px',
		color: '#575757',
		'&:last-child':{
			marginBottom: '0px',
		}
	},
	loadingContainer:{
		display: 'inline-grid',
	},
	backToLogin:{
		cursor:'pointer',
		color: '#497FB1!important',
		'&:hover':{
			textDecoration:'underline',
		}
	}
	// toasterStyle:{
    //     marginTop:'100px',
    // }

}));

function LoginPage() {
	const dispatch = useDispatch();
	const classes = useStyles();
	const {t} = useTranslation('auth');
	const stateAuth = useSelector(({ auth }) => auth.login);
	const [btnAccountNotActivated, setBtnAccountNotActivated] = useState(false);
	const [processResendEmailVerif, setProcessResendEmailVerif] = useState(false);


	useEffect(()=>{
		dispatch(Actions.resetNavigation());
	},[dispatch])


	const [state, setState] = useState({
		email: '',
		password: '',
		remember: false ,
		keepLogged: localStorage.getItem('remindMe') ? localStorage.getItem('remindMe') : false ,
	});

	const handleChange = (event) => {
		const name = event.target.name;
		setState({
			...state,
			[name]: event.target.value,
		});
	};

	/*const handleChangeKeepLogged = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
		localStorage.setItem('remindMe', event.target.checked);
	};*/
	
	function handleSubmit(ev) {
		ev.preventDefault();
		dispatch(submitLogin({ email: state.email, password: state.password }));
	}

	const backToLogin = () =>{
		setBtnAccountNotActivated(false)
		toast.remove();
	}

	//::Resend verification email
	const submitResendVerif= () =>{
		let send_data = {
			"email": state.email, 
		}
		setProcessResendEmailVerif(true)
		return new Promise((resolve, reject) => {
			axios.post(process.env.REACT_APP_SERVER + '/api/auth/resend-verify-email-login', send_data).then(response => {
				if (response.data) {
					resolve(response.data);
					toast.success(t('resend_verify_email_success'));
					setProcessResendEmailVerif(false)
				} else {
					reject(response.data.error);
					toast.error(t('resend_verify_email_error'));
					setProcessResendEmailVerif(false)
				}
			});
		});
	}

	const [values, setValues] = React.useState({
		amount: '',
		password: '',
		weight: '',
		weightRange: '',
		showPassword: false,
	  });

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	function clickLogin(){
		/*console.log("click on login >>> ", clickLogin, stateAuth)
		
		if(toasterActions !== null && toasterActions === false && stateAuth !== null && 
			stateAuth.error && stateAuth.error.data && stateAuth.error.data.errors.password !== "Please activate your account first"){
			toast.error(t('something_went_wrong'));
			
		} else{
			toast.remove();
		}
		if(stateAuth !== null && stateAuth.error && stateAuth.error.data && stateAuth.error.data.errors.password === "Please activate your account first"){
			console.log("account_not_activated")
			toast.error(t('account_not_activated'));
			setBtnAccountNotActivated(true)
			
		} else{
			setBtnAccountNotActivated(false)
			//toast.remove();
		} */
	}

	useEffect(()=>{
		stateAuth && stateAuth.error && stateAuth.error.data.isError === true && stateAuth.error.data.errors.error === "Please enter a valid credentials" && stateAuth.error.data.errors.password !== "Please activate your account first" && toast.error(t('something_went_wrong'));
		stateAuth && stateAuth.error && stateAuth.error.data.isError === true && stateAuth.error.data.errors.password === "Please activate your account first" && stateAuth.error.data.errors.error !== "Please enter a valid credentials" && toast.error(t('account_not_activated'));
		setTimeout(() => {
			toast.remove();
		}, "1000")
	},[stateAuth, t])

	return (
		<>
			<Toaster
				toastOptions={{
					className:classes.toasterStyle,
				}}
			/> 
			<HeaderAuth />
			<div className={clsx(classes.root, 'flex flex-col flex-auto flex-shrink-0 items-center justify-center p-32')}>
				<div className="flex flex-col items-center justify-center w-full">
					<FuseAnimate /*animation="transition.expandIn"*/>
						<Card className={clsx(classes.containerLogin, 'w-full max-w-640')}>
							<CardContent className="flex flex-col items-center justify-center p-32">
								{/* <img className={classes.logo} src="assets/images/logos/scai_logo.svg" alt="SCAI logo" /> */}
								<span className={classes.welcome}>{t('welcome')}</span>
								<p className={clsx('mb-20',classes.txtLogin)}>{t('login_into_your_account')}</p>

								{processResendEmailVerif === false ?
								<>
								<form
									name="loginForm"
									className="flex flex-col justify-center w-full"
									onSubmit={handleSubmit}
								>
									<TextField
										className="mb-16"
										label={t("email")}
										autoFocus
										type="email"
										name="email"
										onChange={handleChange}
										variant="outlined"
										required
										fullWidth
									/>

									<TextField
										className="mb-16"
										label={t("password")}
										
										name="password"
										onChange={handleChange}
										variant="outlined"
										required
										fullWidth
										InputProps={{
											endAdornment:(
												<InputAdornment position="end">
												  <IconButton
													aria-label="toggle password visibility"
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
												  >
													{values.showPassword ? <Visibility /> : <VisibilityOff />}
												  </IconButton>
												</InputAdornment>
											)

										}}
										type={values.showPassword ? 'text' : 'password'}
										
									/>
									{btnAccountNotActivated === false &&
									<>
										<div className="flex items-center justify-between hidden">
											<FormControl>
												<FormControlLabel
													control={
														<Checkbox
															name="remember"
															checked={state.remember}
															onChange={handleChange}
														/>
													}
													label="Remember Me"
												/>
											</FormControl>
										</div>

										{/* <div className="flex items-center justify-between">
											<FormControl>
												<FormControlLabel
													control={
														<Checkbox
															name="keepLogged"
															checked={state.keepLogged}
															onChange={handleChangeKeepLogged}
														/>
													}
													label={t('keep_me_login')}
												/>
											</FormControl>
										</div> */}

										<Link className={clsx(classes.forgotPassword, 'font-medium')} to="/forgot-password">
											{t('forgot_password')}
										</Link>
									</>
									}

									{btnAccountNotActivated === true && 
										<Button
											variant="contained"
											color="primary"
											className="w-full bt-default mx-auto mt-16"
											aria-label={t('resend_verification_email')}
											type="submit"
											onClick={submitResendVerif}
										>
											{t('resend_verification_email')}
										</Button>
									}

									{btnAccountNotActivated === false &&
										<Button
											variant="contained"
											color="primary"
											className="w-full bt-default mx-auto mt-16"
											aria-label="LOG IN"
											type="submit"
											onClick={() => clickLogin()}
										>
											{t('login')}
										</Button>
									}
								</form>

								{btnAccountNotActivated === true && 
									<div className={clsx(classes.backToLogin,"flex flex-col items-center justify-center pt-32 pb-24")} onClick={backToLogin}>
										{t('back_to_login')}
									</div>
								}

								{/* 
								<div className="flex flex-col items-center justify-center pt-32 pb-24">
									<span className="font-medium">{t('need_an_account')}</span>
									<Link className={clsx("font-medium mt-10", classes.signUp)} to="/signup">
										{t('sign_up_now')}
									</Link>
								</div>
								*/}
							</>
							:
								<div className={classes.greyBox}>
									<p className={classes.notif}>{t('processing_resend_email')}</p>
									<div className={classes.loadingContainer}>
										<Plane ariaLabel="loading-indicator" />
									</div>
								</div>
							}	
							</CardContent>
						</Card>
					</FuseAnimate>
				</div>
			</div>
		</>
	);
}

export default LoginPage;
